import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { RouterModule } from '@angular/router';

import { FormsLayoutComponent } from './forms-layout.component';
import { MatIconModule } from '@angular/material/icon';


@NgModule({
	declarations: [
		FormsLayoutComponent,
		HeaderComponent,
		FooterComponent
	],
	imports: [
		RouterModule,
		CommonModule,

		MatIconModule

	]
})
export class FormsLayoutModule { }
